import React from "react";
import { Link } from "react-router-dom";
import Team_1 from '../../../assets/images/team/team-1.png';
import Team_2 from '../../../assets/images/team/team-2.png';
import Team_3 from '../../../assets/images/team/team-3.png';
import Team_4 from '../../../assets/images/team/team-4.png';
import Team_5 from '../../../assets/images/team/team-5.png';
import Team_6 from '../../../assets/images/team/team-6.png';
import Team_7 from '../../../assets/images/team/team-7.png';
import Team_8 from '../../../assets/images/team/team-8.png';
import Team_9 from '../../../assets/images/team/team-9.png';

const teamMembers = [
  {
    name: "Alex Jason",
    position: "Finance consultant",
    image: Team_1,
    socialLinks: [
      { platform: "Facebook", url: "https://www.facebook.com/", icon: "assets/images/svg/header/Fb.svg" },
      { platform: "Twitter", url: "https://x.com/", icon: "assets/images/svg/header/Twiter.svg" },
      { platform: "Instagram", url: "https://www.instagram.com/", icon: "assets/images/svg/header/Insta.svg" },
      { platform: "Pinterest", url: "https://www.pinterest.com/", icon: "assets/images/svg/header/Pintrest.svg" },
    ],
  },
  {
    name: "Martin Doe",
    position: "Sale Director",
    image: Team_4,
    socialLinks: [
      { platform: "Facebook", url: "https://www.facebook.com/", icon: "assets/images/svg/header/Fb.svg" },
      { platform: "Twitter", url: "https://x.com/", icon: "assets/images/svg/header/Twiter.svg" },
      { platform: "Instagram", url: "https://www.instagram.com/", icon: "assets/images/svg/header/Insta.svg" },
      { platform: "Pinterest", url: "https://www.pinterest.com/", icon: "assets/images/svg/header/Pintrest.svg" },
    ],
  },
  {
    name: "Richard Divas",
    position: "Business Advisor",
    image: Team_3,
    socialLinks: [
      { platform: "Facebook", url: "https://www.facebook.com/", icon: "assets/images/svg/header/Fb.svg" },
      { platform: "Twitter", url: "https://x.com/", icon: "assets/images/svg/header/Twiter.svg" },
      { platform: "Instagram", url: "https://www.instagram.com/", icon: "assets/images/svg/header/Insta.svg" },
      { platform: "Pinterest", url: "https://www.pinterest.com/", icon: "assets/images/svg/header/Pintrest.svg" },
    ],
  },
  {
    name: "Monalis",
    position: "Manager",
    image: Team_5,
    socialLinks: [
      { platform: "Facebook", url: "https://www.facebook.com/", icon: "assets/images/svg/header/Fb.svg" },
      { platform: "Twitter", url: "https://x.com/", icon: "assets/images/svg/header/Twiter.svg" },
      { platform: "Instagram", url: "https://www.instagram.com/", icon: "assets/images/svg/header/Insta.svg" },
      { platform: "Pinterest", url: "https://www.pinterest.com/", icon: "assets/images/svg/header/Pintrest.svg" },
    ],
  },
  {
    name: "Sarah Hanley",
    position: "Product Manager",
    image: Team_2,
    socialLinks: [
      { platform: "Facebook", url: "https://www.facebook.com/", icon: "assets/images/svg/header/Fb.svg" },
      { platform: "Twitter", url: "https://x.com/", icon: "assets/images/svg/header/Twiter.svg" },
      { platform: "Instagram", url: "https://www.instagram.com/", icon: "assets/images/svg/header/Insta.svg" },
      { platform: "Pinterest", url: "https://www.pinterest.com/", icon: "assets/images/svg/header/Pintrest.svg" },
    ],
  },
  {
    name: "Richard Divas",
    position: "Business Advisor",
    image: Team_6,
    socialLinks: [
      { platform: "Facebook", url: "https://www.facebook.com/", icon: "assets/images/svg/header/Fb.svg" },
      { platform: "Twitter", url: "https://x.com/", icon: "assets/images/svg/header/Twiter.svg" },
      { platform: "Instagram", url: "https://www.instagram.com/", icon: "assets/images/svg/header/Insta.svg" },
      { platform: "Pinterest", url: "https://www.pinterest.com/", icon: "assets/images/svg/header/Pintrest.svg" },
    ],
  },
  {
    name: "Monalis",
    position: "Manager",
    image: Team_7,
    socialLinks: [
      { platform: "Facebook", url: "https://www.facebook.com/", icon: "assets/images/svg/header/Fb.svg" },
      { platform: "Twitter", url: "https://x.com/", icon: "assets/images/svg/header/Twiter.svg" },
      { platform: "Instagram", url: "https://www.instagram.com/", icon: "assets/images/svg/header/Insta.svg" },
      { platform: "Pinterest", url: "https://www.pinterest.com/", icon: "assets/images/svg/header/Pintrest.svg" },
    ],
  },
  {
    name: "Sarah Hanley",
    position: "Product Manager",
    image: Team_8,
    socialLinks: [
      { platform: "Facebook", url: "https://www.facebook.com/", icon: "assets/images/svg/header/Fb.svg" },
      { platform: "Twitter", url: "https://x.com/", icon: "assets/images/svg/header/Twiter.svg" },
      { platform: "Instagram", url: "https://www.instagram.com/", icon: "assets/images/svg/header/Insta.svg" },
      { platform: "Pinterest", url: "https://www.pinterest.com/", icon: "assets/images/svg/header/Pintrest.svg" },
    ],
  },
  {
    name: "Sarah Hanley",
    position: "Product Manager",
    image: Team_9,
    socialLinks: [
      { platform: "Facebook", url: "https://www.facebook.com/", icon: "assets/images/svg/header/Fb.svg" },
      { platform: "Twitter", url: "https://x.com/", icon: "assets/images/svg/header/Twiter.svg" },
      { platform: "Instagram", url: "https://www.instagram.com/", icon: "assets/images/svg/header/Insta.svg" },
      { platform: "Pinterest", url: "https://www.pinterest.com/", icon: "assets/images/svg/header/Pintrest.svg" },
    ],
  },
];

const TeamOne = () => {
  return (
    <div className="team-section-one">
      <div className="container">
        <div className="row">
          <div className="col-xl-5 m-auto">
            <div className="heading-box text-center">
              <span className="sub-title animate fadeInUp wow" data-wow-duration="1500ms">
                Team
              </span>
              <h2 className="heading-title animate fadeInUp wow" data-wow-duration="1500ms" data-wow-delay="200ms">
                Our Team of Dedicated Digital Professionals
              </h2>
            </div>
          </div>
        </div>
        <div className="row justify-content-center gutter-y-60">
          {teamMembers.map((member, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
              <div className="team-box-one animate fadeInUp wow" data-wow-duration="1500ms" data-wow-delay={`${index * 200}ms`}>
                <div className="team-image-one">
                  <Link to="#">
                    <img src={member.image} alt="team-image" />
                  </Link>
                </div>
                <div className="team-details-one">
                  <h4>
                    <Link to="#">{member.name}</Link>
                  </h4>
                  <p>{member.position}</p>
                </div>
                <ul className="team-social-media-one">
                  {member.socialLinks.map((link, linkIndex) => (
                    <li key={linkIndex}>
                      <Link to={link.url}>
                        <img src={link.icon} alt={link.platform} />
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TeamOne;